<template>
    <div id="app" :class="userAgentClasses">
        <search-tool-module />
    </div>
</template>

<script>

    import SearchToolModule from './components/SearchToolModule';
    import ieUserAgent from './utils/libs'

    export default {
        name: 'App',
        components: {SearchToolModule},
        computed: {
            userAgentClasses() {
                const userAgent = ieUserAgent();
                let browserClasses = [];

                if (userAgent.compatibilityMode) {
                    browserClasses.push("ie");
                    browserClasses.push("ie" + userAgent.version);
                }

                return browserClasses.join(" ");
            }
        }
    };
</script>

<style lang="scss" type="text/scss">
    @import "styles/main";

    #app {
        position: relative;
        z-index: 1;
    }
</style>
